import axios from "../../util/axios";

const PREFIX_URI = "/luqiao/workers/card/replace";

export default {
    /** 查询列表 */
    list: (data) => axios.get({url: `${PREFIX_URI}/list`, data: data}),

    /** 保存 */
    saveSubmit:  (data) => axios.post({url: `${PREFIX_URI}/saveSubmit`, data: data}),

    /** 删除 */
    delete: (id) => axios.get({url: `${PREFIX_URI}/delete`, data: {id: id}}),
    /** 获取劳务人员缺卡的最近一天的时间，只查询当月 */
    getAttendanceLack: (data) => axios.get({url: `${PREFIX_URI}/getAttendanceLack`, data: data}),


}